<app-barra-crud [state]="state" (salvando)="salvar()" (voltando)="busca()" (inserindo)="novo()" (editando)="editar()"
    (excluindo)="excluir()" (cancelando)="cancelar()" [exibirNovo]="exibirNovo" [exibirExcluir]="exibirExcluir"
    [formValido]="f.valid">
</app-barra-crud>

<div class="conteudo cadastro">
    <form role="form" #f="ngForm" novalidate>
        <nav class="topo-abas">
            <div class="nav nav-tabs" id="nav-tab" role="tablist">
                <a translate id="dados-principais-tab" href="#dados-principais" aria-controls="dados-principais"
                    aria-selected="true" class="nav-item nav-link active" data-toggle="tab" role="tab">
                    {{'parametros.indiceProdutividade.cadastro.dadosPrincipais.abaDadosPrincipais'}}
                </a>
            </div>
        </nav>
        <div class="tab-content" id="nav-tabContent">
            <div id="dados-principais" aria-labelledby="dados-principais-tab" class="tab-pane fade show active"
                role="tabpanel">
                <header translate class="titulo">
                    {{'parametros.indiceProdutividade.cadastro.dadosPrincipais.abaDadosPrincipais'}}
                </header>

                <div class="container-fluid">
                    <div class="row">
                        <div class="col col-lg-12">
                            <small translate
                                class="text-info">{{'parametros.indiceProdutividade.cadastro.CampoObrigatorio'}}</small>
                            <hr />
                        </div>
                    </div>
                    <div class="row">
                        <app-text-box [state]="state" class="col-lg-4"
                            label="{{'parametros.indiceProdutividade.cadastro.dadosPrincipais.produtividade' | translate}}"
                            name="maoDeObra" obrigatorio="true" required [(ngModel)]="model.maoDeObra"
                            placeholder="{{'parametros.indiceProdutividade.cadastro.dadosPrincipais.produtividadePlaceHolder' | translate}}">
                        </app-text-box>

                        <app-text-box [state]="state" class="col-lg-4"
                            label="{{'parametros.indiceProdutividade.cadastro.dadosPrincipais.eficiencia' | translate}}"
                            name="produtividade" obrigatorio="true" required [(ngModel)]="model.produtividade"
                            placeholder="{{'parametros.indiceProdutividade.cadastro.dadosPrincipais.eficienciaPlaceHolder' | translate}}">
                        </app-text-box>

                        <app-text-box [state]="state" class="col-lg-4"
                            label="{{'parametros.indiceProdutividade.cadastro.dadosPrincipais.utilizacao' | translate}}"
                            name="eficiencia" obrigatorio="true" required [(ngModel)]="model.eficiencia"
                            placeholder="{{'parametros.indiceProdutividade.cadastro.dadosPrincipais.utilizacaoPlaceHolder' | translate}}">
                        </app-text-box>
                    </div>
                </div>
            </div>
        </div>
    </form>
</div>